import { FormSourceBreakdownRow } from '@features/forms/types';
import { FormOverviewSourceBreakdownApi } from '@features/forms/types/formOverviewApi';

/** API sends conversion_rate as a string; decimal fractions map to percent (e.g. "0.02" → 2%). */
export const toSourceConversionPercent = (rate: string | undefined): number => {
  if (!rate?.trim()) {
    return 0;
  }
  const parsed = Number(rate);
  if (!Number.isFinite(parsed)) {
    return 0;
  }
  if (parsed > 0 && parsed <= 1) {
    return parsed * 100;
  }
  return parsed;
};

export const mapSourceBreakdown = (
  rows: FormOverviewSourceBreakdownApi[] | undefined
): FormSourceBreakdownRow[] =>
  (rows ?? []).map((row) => ({
    source: row.source,
    views: row.viewed_count,
    paid: row.paid_count,
    convRate: toSourceConversionPercent(row.conversion_rate)
  }));

export default mapSourceBreakdown;
